import { render, staticRenderFns } from "./TemplateSafetyCheck444Index.vue?vue&type=template&id=2857dda6&scoped=true&"
import script from "./TemplateSafetyCheck444Index.vue?vue&type=script&lang=js&"
export * from "./TemplateSafetyCheck444Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857dda6",
  null
  
)

export default component.exports